export const esMarcaPersonalPalettes = [
  {
    palette: ["#F7F3ED", "#D9C7B8", "#B3836E", "#684C46", "#282525"],
    paletteName: "Cálida y experta",
    paletteDescription:
      "Neutros cálidos y terracota para una marca personal cercana, humana y profesional.",
  },
  {
    palette: ["#F4F8FB", "#B8D4E3", "#6D9FB8", "#356078", "#182B38"],
    paletteName: "Confianza azul",
    paletteDescription:
      "Una combinación serena para consultoría, educación, tecnología y servicios basados en confianza.",
  },
  {
    palette: ["#FFF9E9", "#F6D365", "#E6A12D", "#C05B2E", "#4E2D28"],
    paletteName: "Optimismo creativo",
    paletteDescription:
      "Amarillo, naranja y cacao para una identidad enérgica que quiere llamar la atención con calidez.",
  },
  {
    palette: ["#F5F5F2", "#D8D8D2", "#999B93", "#4B514B", "#202420"],
    paletteName: "Minimalista editorial",
    paletteDescription:
      "Neutros y carbón para una marca sobria, limpia y centrada en el contenido.",
  },
  {
    palette: ["#F2FAF3", "#C7E3CC", "#83B58D", "#437052", "#263F31"],
    paletteName: "Verde consciente",
    paletteDescription:
      "Verdes naturales para bienestar, sostenibilidad, nutrición o proyectos conectados con la naturaleza.",
  },
  {
    palette: ["#FCF4F8", "#F0C6D8", "#D27B9F", "#8C426B", "#3C2636"],
    paletteName: "Rosa con carácter",
    paletteDescription:
      "Una paleta expresiva y elegante para creatividad, belleza, moda y comunicación personal.",
  },
  {
    palette: ["#F5F2FA", "#D7C8EA", "#9B7BC1", "#604283", "#2D243B"],
    paletteName: "Índigo estratégico",
    paletteDescription:
      "Violetas profundos que aportan diferenciación, imaginación y una sensación digital contemporánea.",
  },
  {
    palette: ["#FFF8F0", "#E8C49A", "#C8834E", "#88462F", "#342421"],
    paletteName: "Artesanía terracota",
    paletteDescription:
      "Tonos de barro y cuero para oficios, gastronomía, diseño y proyectos con una dimensión manual.",
  },
  {
    palette: ["#F0FBFC", "#BDE3E6", "#63B7BD", "#2D747A", "#1E3C40"],
    paletteName: "Turquesa clara",
    paletteDescription:
      "Fresca y accesible, ideal para una marca personal que quiere transmitir claridad y movimiento.",
  },
  {
    palette: ["#FAF7F0", "#D9D0C2", "#AA9274", "#6A5546", "#252321"],
    paletteName: "Lujo tranquilo",
    paletteDescription:
      "Una base discreta con tonos piedra y café para servicios premium, arquitectura o dirección creativa.",
  },
];
